"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreActionTypes = void 0;
var StoreActionTypes;
(function (StoreActionTypes) {
    StoreActionTypes["AddAlert"] = "ADD_ALERT";
    StoreActionTypes["RemoveAlert"] = "REMOVE_ALERT";
    StoreActionTypes["RemoveAllAlerts"] = "REMOVE_ALL_ALERTS";
})(StoreActionTypes = exports.StoreActionTypes || (exports.StoreActionTypes = {}));
var createStatusAlertStore = function (reducer, initialState) {
    var state = initialState;
    var listeners = [];
    var getState = function () { return state; };
    var dispatch = function (action) {
        state = reducer(state, action);
        listeners.forEach(function (listener) { return listener(); });
    };
    var subscribe = function (listener) {
        listeners.push(listener);
        return function () {
            listeners = listeners.filter(function (l) { return l !== listener; });
        };
    };
    return { getState: getState, dispatch: dispatch, subscribe: subscribe };
};
var statusAlertReducer = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case StoreActionTypes.AddAlert:
            return __spreadArray(__spreadArray([], state, true), [action.payload], false);
        case StoreActionTypes.RemoveAlert:
            return __spreadArray([], state.filter(function (item) { return item.id !== action.payload; }), true);
        case StoreActionTypes.RemoveAllAlerts:
            return [];
        default:
            return state;
    }
};
var statusAlertStore = createStatusAlertStore(statusAlertReducer, []);
exports.default = statusAlertStore;
